import { MediaHelpers } from '@wajeez-web/core/api';
import { Content } from '@wajeez-web/core/api-base';

export const getCardValueByKey = (
  key: string,
  contentType: string,
  itemTemplate?: Content.ComponentOutput | null
) => {
  if (itemTemplate?.parameters?.[key]?.mappingOptions?.length) {
    return itemTemplate?.parameters?.[key]?.mappingOptions?.find(
      (ele) => ele.contentEntityType === contentType
    )?.entityTypeField;
  }
  return itemTemplate?.parameters?.[key]?.value;
};

